module.exports = __webpack_public_path__ + "media/images/pc/specials/fair/bg_01-0b853467bedd2d972929e43745efad85.jpg";